import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail, track } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("Password must be at least 8 characters.");
    if (pw !== confirm) return setError("Passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      track("password_reset_completed");
      toast.success("Your password has been reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FCFAF6] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2.5">
          <span className="w-10 h-10 rounded-2xl bg-[#291B2D] text-white flex items-center justify-center font-heading text-lg">S<span className="text-[#C89B55]">+</span></span>
          <span className="font-heading text-2xl">Sisterhood<span className="text-[#C89B55]">+</span></span>
        </Link>
        <h1 className="font-display text-3xl lg:text-4xl font-semibold mt-8">Choose a new password</h1>
        <p className="text-[#59535B] mt-2">Make it something you'll remember.</p>
        {!token && (
          <p data-testid="reset-no-token" className="mt-4 text-sm text-[#9E3A3A]">This reset link is missing its token. Please use the link from your email.</p>
        )}
        {error && <div data-testid="reset-error" className="mt-6 bg-[#FAF0F0] border border-[#9E3A3A]/30 text-[#9E3A3A] rounded-xl px-4 py-3 text-sm">{error}</div>}
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="reset-password-input" type="password" required value={pw} placeholder="New password"
            onChange={(e) => setPw(e.target.value)}
            className="w-full bg-[#FCFAF6] border border-[#E5DED4] rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C89B55]" />
          <input data-testid="reset-confirm-input" type="password" required value={confirm} placeholder="Confirm new password"
            onChange={(e) => setConfirm(e.target.value)}
            className="w-full bg-[#FCFAF6] border border-[#E5DED4] rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C89B55]" />
          <button data-testid="reset-submit" type="submit" disabled={loading || !token}
            className="w-full rounded-full bg-[#291B2D] text-[#FCFAF6] hover:bg-[#352238] transition-all px-7 py-3.5 font-medium disabled:opacity-60">
            {loading ? "Resetting…" : "Reset password"}
          </button>
        </form>
        <Link to="/login" className="mt-6 inline-block text-sm text-[#8A838E] hover:text-[#291B2D] underline underline-offset-4">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
